import { Injectable } from '@angular/core';
import { productSwitchModalId } from '../../retailer-platform/order/product-switch-modal/product-switch-modal.component';
import { FcpModalService } from 'fc-ui-components';
import { OrderSheetItem } from 'app/b2b-order/services/order-sheet/types';
import { OrderSheetService } from '../order-sheet';
import { ShoppingCartItem, ShoppingCartService } from '../shopping-cart';

@Injectable()
export class ProductSwitchService {
    public articlesToAddAfterProductSwitch: (ShoppingCartItem | OrderSheetItem)[] = [];

    constructor(
        private shoppingCartService: ShoppingCartService,
        private orderSheetService: OrderSheetService,
        private fcpModalService: FcpModalService
    ) {}

    addArticlesAndDisplayProductSwitchModalIfNeededForReorder(items: ShoppingCartItem[]) {
        const hasPreorderArticles = this.orderSheetService.items.value.length > 0;
        if (hasPreorderArticles) {
            this.displayClearCartOnProductSwitchModal();
            this.articlesToAddAfterProductSwitch = items;
        } else {
            this.shoppingCartService.add(items);
        }
    }

    addArticlesAndDisplayProductSwitchModalIfNeededForPreorder(items: OrderSheetItem[]) {
        const hasReorderArticles = this.shoppingCartService.items.value.length > 0;
        if (hasReorderArticles) {
            this.displayClearCartOnProductSwitchModal();
            this.articlesToAddAfterProductSwitch = items;
        } else {
            this.orderSheetService.add(items);
        }
    }

    private displayClearCartOnProductSwitchModal() {
        this.fcpModalService.open(productSwitchModalId);
    }
}
